import { render, staticRenderFns } from "./CustomerOnHold.vue?vue&type=template&id=1cb46a41&scoped=true"
import script from "./CustomerOnHold.vue?vue&type=script&lang=ts"
export * from "./CustomerOnHold.vue?vue&type=script&lang=ts"
import style0 from "./CustomerOnHold.vue?vue&type=style&index=0&id=1cb46a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb46a41",
  null
  
)

export default component.exports